import PaybacksView from './PaybacksView';

export default PaybacksView;



// WEBPACK FOOTER //
// ./src/views/payoutsAndTaxes/paybacks/index.js